// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfirmDeleteTrackerModal_wrapper__DHa8V"};